import { Injectable, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ParamsSendLogs } from 'mbs-ui-shared@models/ComputersModals';
import { Ticket } from 'mbs-ui-shared@modules';
import { SupportPortalService } from 'mbs-ui-shared@services/support-portal.service';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class SupportPortalFacade {
  private supportPortalService = inject(SupportPortalService);

  private accountManager$ = this.supportPortalService.getAccountManager().pipe(shareReplay(1));

  photoPath = this.supportPortalService.photoPath;

  getAccountManager() {
    return this.accountManager$;
  }

  sendReportToSupport(params: Partial<Ticket>) {
    return this.supportPortalService.sendReportToSupport(params);
  }

  unreadMessagesCount(): Observable<{ count: number }> {
    return this.supportPortalService.unreadMessagesCount();
  }

  sendReportProblem(params: Partial<ParamsSendLogs>): Observable<boolean> {
    return this.supportPortalService.sendReportProblem(params);
  }
}
